<script lang="ts">
  export let customClass: string | undefined = '';
</script>

<svg
  width="12"
  height="7"
  viewBox="0 0 12 7"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={customClass}
>
  <path
    d="M11 6L6 1L1 6"
    stroke="#667085"
    style="stroke:#667085;stroke:color(display-p3 0.4009 0.4408 0.5207);stroke-opacity:1;"
    stroke-width="1.67"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
